import api from "./axiosInstance";
import { API_ENDPOINTS } from "../config/apiconfig";

const purchaseApi = {
  // Get all purchase orders
  getAll: async () => {
    const response = await api.get(API_ENDPOINTS.PURCHASE.GET_ALL);
    return response.data;
  },

  // Get purchase order by ID
  getById: async (id) => {
    const response = await api.get(API_ENDPOINTS.PURCHASE.GET_BY_ID(id));
    return response.data;
  },

  // Create new purchase order
  create: async (purchaseData) => {
    const response = await api.post(API_ENDPOINTS.PURCHASE.CREATE, purchaseData);
    return response.data;
  },

  // Update existing purchase order
  update: async (id, purchaseData) => {
    const response = await api.put(API_ENDPOINTS.PURCHASE.UPDATE(id), purchaseData);
    return response.data;
  },

  // Delete purchase order
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.PURCHASE.DELETE(id));
    return response.data;
  },

  // Save as draft
  saveDraft: async (purchaseData) => {
    const response = await api.post("purchase/saveDraft", purchaseData);
    return response.data;
  },

  // Get all drafts
  getDrafts: async () => {
    const response = await api.get("purchase/getDrafts");
    return response.data;
  },

  // Get draft by ID
  getDraftById: async (id) => {
    const response = await api.get(`purchase/getDraft/${id}`);
    return response.data;
  },

  // Search purchase orders by filters
  search: async (filters) => {
    const response = await api.post(API_ENDPOINTS.PURCHASE.SEARCH, filters);
    return response.data;
  },

  // Get purchase order by number
  getByPurchaseOrderNumber: async (poNumber) => {
    const response = await api.get("purchase/getByPONumber", {
      params: { poNumber },
    });
    return response.data;
  },

  // Get purchase orders by vendor ID
  getByVendorId: async (vendorId) => {
    const response = await api.get(API_ENDPOINTS.PURCHASE.GET_BY_VENDOR_ID(vendorId));
    return response.data;
  },

  // Export purchase order (PDF, etc)
  export: async (id, format = "pdf") => {
    const response = await api.get(`purchase/export/${id}`, {
      params: { format },
      responseType: "blob",
    });
    return response.data;
  },

  // Approve purchase order
  approve: async (id, approverNotes = "") => {
    const response = await api.put(`purchase/approve/${id}`, {
      approverNotes,
    });
    return response.data;
  },

  // Reject purchase order
  reject: async (id, rejectionReason = "") => {
    const response = await api.put(`purchase/reject/${id}`, {
      rejectionReason,
    });
    return response.data;
  },

  // Cancel purchase order
  cancel: async (id, cancellationReason = "") => {
    const response = await api.put(`purchase/cancel/${id}`, {
      cancellationReason,
    });
    return response.data;
  },

  // Get purchase statistics
  getStats: async (filters = {}) => {
    const response = await api.post("purchase/stats", filters);
    return response.data;
  },

  // Get vendor passbook summary
  getVendorPassbookSummary: async (vendorId, fromDate, toDate) => {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await api.get(
      API_ENDPOINTS.VENDOR_PASSBOOK.GET_SUMMARY(vendorId),
      { params }
    );
    return response.data;
  },

  // Get vendor statement
  getVendorStatement: async (vendorId, fromDate, toDate) => {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await api.get(
      API_ENDPOINTS.VENDOR_PASSBOOK.GET_STATEMENT(vendorId),
      { params }
    );
    return response.data;
  },

  // Get vendor product statement
  getVendorProductStatement: async (vendorId, goodsItemId, fromDate, toDate) => {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await api.get(
      API_ENDPOINTS.VENDOR_PASSBOOK.GET_PRODUCT_STATEMENT(
        vendorId,
        goodsItemId
      ),
      { params }
    );
    return response.data;
  },

  // Get vendor inventory
  getVendorInventory: async (vendorId) => {
    const response = await api.get(
      API_ENDPOINTS.VENDOR_PASSBOOK.GET_INVENTORY(vendorId)
    );
    return response.data;
  },
};

export default purchaseApi;
